import $ from 'jquery';
import 'stylesheets/select2';
import select2 from 'select2/dist/js/select2';

$(() => {
  $('.select2').select2({ theme: 'bootstrap', multiple: true, placeholder: 'Please select...' });
});